// hooks/usePermissionsFromJWT.js
import { useMemo, useEffect } from "react";
import jwtDecode from "jwt-decode";

export const usePermissionsFromJWT = () => {
  const token = sessionStorage.getItem("authToken");

  const data = useMemo(() => {
    if (!token) return { permissions: [] };

    try {
      const decoded = jwtDecode(token);
      const raw =
        decoded.PERMISSION ??
        decoded.permissions ??
        decoded.Permission ??
        [];

      // Normalize to string array (backend may return objects with permissionCode)
      const permissions = Array.isArray(raw)
        ? raw.map((p) => (typeof p === "string" ? p : p?.permissionCode ?? p?.name ?? "")).filter(Boolean)
        : [];

      return { permissions };
    } catch (err) {
      console.error("Invalid token:", err);
      return { permissions: [] };
    }
  }, [token]);

  return data;
};
export const useSessionExpiryChecker = (token, onExpire) => {
  useEffect(() => {
    if (!token) return;

    const decoded = jwtDecode(token);
    const expirationTime = decoded.exp * 1000;

    const intervalId = setInterval(() => {
      if (Date.now() >= expirationTime) {
        onExpire();
        clearInterval(intervalId);
      }
    }, 2000);

    return () => clearInterval(intervalId);
  }, [token, onExpire]);
};
